import {Component, OnInit, TemplateRef} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { forkJoin } from 'rxjs/index';
import { FilterService } from '../services/filter/filter.service';
import { GenericFilter } from '../model/filter/genericFilter.model';
import { ConfigurationService } from '../services/configuration/configuration.service';
import { PanelConfigurationWorkingDayResult } from '../model/configuration/panelConfigurationWorkingDayResult.model';
import {
  PanelConfigurationIndicatorWorkingDay, PanelConfigurationIndicatorWorkingDayItem
} from '../model/configuration/panelConfigurationWorkingDay.model';
import {
  PanelConfigurationNonWorkingDay,
  PanelConfigurationNonWorkingDayModel
} from '../model/configuration/panelConfigurationNonWorkingDay.model';
import { ToastrService } from 'ngx-toastr';
import { BusinessProcessDimension, BusinessProcessDimensionListResult } from '../model/configuration/businessProcessDimension.model';
import { StateDimension } from '../model/configuration/stateDimension.model';
import { PanelConfigurationNonWorkingDayResult } from '../model/configuration/panelConfigurationNonWorkingDayResult.model';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { BehaviorSubject } from 'rxjs';
import {GenericModalService} from '../services/utils/generic-modal.service';
declare var $: any;

export interface SelectOption {
  id?: string;
  text?: string;
}

@Component({
  selector: 'app-working-days',
  templateUrl: './working-days.component.html',
  styleUrls: ['./working-days.component.css']
})
export class WorkingDaysComponent implements OnInit {

  filterCollapse$: BehaviorSubject<boolean>;

  panelConfigurationWorkingDay: PanelConfigurationIndicatorWorkingDay;
  businessProcessDimensionList: Array<BusinessProcessDimension> = [];
  nonWorkingDays: Array<PanelConfigurationNonWorkingDay> = [];
  workingDayItem: PanelConfigurationIndicatorWorkingDayItem;
  selectedNonWorkingDays: Array<PanelConfigurationNonWorkingDay> = [];
  dayOfWeeks = new DayOfWeeks(false);
  textAction: string;

  bPListSelected: string;
  filteredStatesSelected: string;
  stateDimensionList = [];
  disabled = false;

  businessProcessDimension: BusinessProcessDimension;

  isConfigLoading: boolean;
  isSaving: boolean;
  isEditing: boolean;
  successfullySaved: boolean;
  errorState = false;
  errorStateMessage: string;

  errorBP = false;
  errorBPMessage: string;

  public modalRef: BsModalRef;
  isEditMode: boolean;

  hasSearched = true;
  isEdit: boolean;

  // MODAL
  checkboxDisabled = false;

  items: SelectOption[] = [];
  filter: GenericFilter;

  _listClients: SelectOption[];
  selectedStateDimensionList = [];

  isOpenModal = false;

  entries = [];

  constructor(private filterService: FilterService,
              private configurationService: ConfigurationService,
              private localeService: BsLocaleService,
              private toastr: ToastrService,
              public genericModalService: GenericModalService,
              public bsModalRef: BsModalRef) {

    this.panelConfigurationWorkingDay = new PanelConfigurationIndicatorWorkingDay();
    this.nonWorkingDays = [];
    this.isConfigLoading = false;

  }

  // Reactive forms
  businessProcessCtrl = new FormControl();

  formBusinessProcess = new FormGroup({
    businessProcessList: this.businessProcessCtrl
  });

  receiveFilter($event) {
    this.filter = $event;

    if (this.filter.BusinessProcess === undefined) {
      this.toastr.error('Necessario informar o processo de negócio'
        , 'Erro', { positionClass: 'toast-top-center' });
      return;
    }

    if (this.filter.State.id === undefined) {
      this.toastr.error('Necessario informar o estado'
        , 'Erro', { positionClass: 'toast-top-center' });
      return;
    }

    this.loadConfigurationIndicatorsWorkingDays();
  }

  cleanFilter() {
    this.panelConfigurationWorkingDay = new PanelConfigurationIndicatorWorkingDay();
    this.hasSearched = true;
  }

  loadConfigurationIndicatorsWorkingDays() {

    this.isConfigLoading = true;

    const getPanelConfigurationIndicatorWorkingDaysCall = this.configurationService.listPanelConfigurationIndicatorsWorkingDay(
      this.filter.BusinessProcess.id, this.filter.State.id);

    forkJoin([getPanelConfigurationIndicatorWorkingDaysCall]).subscribe(results => {
      const resultWorkingDayResult: PanelConfigurationWorkingDayResult = results[0] as PanelConfigurationWorkingDayResult;

      if (resultWorkingDayResult.result) {

        this.panelConfigurationWorkingDay = resultWorkingDayResult.result;
        this.isConfigLoading = false;
        this.hasSearched = false;

        if (!this.isOpenModal) {
          // this.collapsableFilter();
        }

        if (this.panelConfigurationWorkingDay.workingDays) {
          this.panelConfigurationWorkingDay.workingDays.forEach(item => {
            item.formatedInitialTime = this.localTimeFromUTC(item.formatedInitialTime);
            item.formatedFinalTime = this.localTimeFromUTC(item.formatedFinalTime);
          });
        }
      }
    });
  }

  localTimeFromUTC (sUtcTime: string) {
    const utcDate = this.toUTCDate(sUtcTime);
    const currentDate = new Date(),
          offset = -(currentDate.getTimezoneOffset() / 60);
    let hours = utcDate.getHours();

    hours += offset;

    const resultDate = new Date(utcDate.getTime());
    resultDate.setHours(hours);

    return resultDate.toLocaleTimeString();
  }

  collapsableFilter() {
    this.filterCollapse$.next(true);
  }

  toUTCDate(sUtcTime: string) {
    sUtcTime = sUtcTime.replace(new RegExp(':', 'g'), '');
    const day = `0${new Date().getUTCDate() + 1}`.slice(-2);
    const month = `0${new Date().getUTCMonth() + 1}`.slice(-2);
    const year = new Date().getUTCFullYear();

    const formated = this.getFormatMask('XX:XX:XX', sUtcTime);
    const newDate = this.getNowUTC(new Date(`${year}-${month}-${day}T${formated}Z`));
    return newDate;
  }

  listNonWorkingDays() {

    this.isConfigLoading = true;
    this.configurationService.listNonWorkingDays().subscribe((resp: PanelConfigurationNonWorkingDayResult) => {
      if (resp.result) {

        this.nonWorkingDays = resp.result;
      } else if (resp.error) {
        this.toastr.error(resp.errorMessage, 'Erro', { positionClass: 'toast-top-center' });
      }
      this.isConfigLoading = false;
    });
  }

  public getBusinessProcess() {
    const getBusinessProcessCall = this.filterService.getBusinessProcess();

    forkJoin([getBusinessProcessCall]).subscribe(results => {
      const resultBPs: BusinessProcessDimensionListResult = results[0] as BusinessProcessDimensionListResult;
      if (resultBPs.result) {

        this.businessProcessDimensionList = resultBPs.result;
      }
    });
  }

  onSelectBP(event: TypeaheadMatch): void {

    this.businessProcessDimension = event.item;

    if (!this.bPListSelected || this.errorBP) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  }

  public refreshValue(value: any): void {
    this.stateDimensionList = value;
  }

  onChangeBusinessProcess(): void {

    if (this.businessProcessDimension !== undefined) {
      this.filterService.getStates(this.businessProcessDimension.businessProcessId).subscribe((resp: any) => {
        if (resp.result) {

          this.itemsLoad(resp.result);
        }
      });
    }
  }

  itemsLoad(result: any) {

    this.items = [];

    result.forEach(item => {

      this.items.push({ id: (item.id.toString()), text: (item.name) });
    });
  }

  onSelect(content: any) {

    this.selectedNonWorkingDays.splice(0, content.selected.length);

    content.selected.forEach(item => {

      this.selectedNonWorkingDays.push(this.nonWorkingDays.find(p => p.id == item.id));
    });
  }

  typeaheadNoResultsState(event: boolean): void {
    this.errorState = event;
    this.errorStateMessage = 'Nenhum resultado encontrado';
  }

  onClickConfirmDelete() {
    this.configurationService.deleteWorkingDay(
      this.filter.BusinessProcess.id, this.filter.State.id
    ).subscribe((resp: any) => {

      if (resp !== null && resp.error !== null && resp.error) {
        this.toastr.error(resp.errorMessage, 'Erro'
          , { positionClass: 'toast-top-center' });
        return;
      }

      this.toastr.success('Configuração de dias úteis/feriados excluída com sucesso! ', 'Sucesso', { positionClass: 'toast-top-center' });
      this.hasSearched = true;
    },
      (err: any) => {
        const error = err.error.message || err.statusText;
        this.toastr.error(error, 'Erro'
          , { positionClass: 'toast-top-center' });

      });

    this.cleanFilter();
  }

  typeaheadNoResultsBP(event: boolean): void {
    this.errorBP = event;
    this.errorBPMessage = 'Nenhum resultado encontrado';

    this.removeStateListSelected();
  }

  removeBPListSelected() {
    this.items = [];
    this.bPListSelected = '';
    this.errorBP = false;

    this.removeStateListSelected();
  }

  removeStateListSelected() {
    this.filteredStatesSelected = '';
    this.errorState = false;
  }

  // MODAL NOVO
  onClickNew(staticModel: TemplateRef<any>) {

    this.isOpenModal = true;
    this.isEdit = false;
    this.dayOfWeeks = new DayOfWeeks(false);

    this.dayOfWeeks.day.forEach(item => {

      this.dayOfWeeks.day[item.weekDay].isError = false;
    });

    this.entries = [
      {
        id: 0,
        description: 'Nenhum'
      },
      {
        id: 1,
        description: 'Todos'
      },
      {
        id: 2,
        description: 'Dias Úteis'
      },
      {
        id: 3,
        description: 'Final de Semana'
      }
    ];

    this.textAction = 'Nova';
    this.isEditMode = false;

    this.items = [];
    this._listClients = [];
    this.selectedStateDimensionList = [];
    this.selectedNonWorkingDays = [];
    this.bPListSelected = '';

    this.NoneChange();

    this.checkboxDisabled = false;

    this.bsModalRef = this.genericModalService.showObjModalWithTemplate(staticModel, {}, 'modal-xl');
  }

  onClickSaveWorkingDay() {

    if (this.businessProcessDimension === undefined) {
      this.toastr.error('Não é possível salvar pois é necessario selecionar um processo de negócio.'
        , 'Erro', { positionClass: 'toast-top-center' });
      return;
    }

    if (this.selectedStateDimensionList === undefined || this.selectedStateDimensionList.length < 1) {
      this.toastr.error('Não é possível salvar pois é necessario selecionar ao menos um estado.'
        , 'Erro', { positionClass: 'toast-top-center' });
      return;
    }

    if (!this.dayOfWeeks.day.find(x => x.dayCheck === true) ? true : false) {
      this.toastr.error('Não é possível salvar pois é necessario configurar ao menos um dia da semana.'
        , 'Erro', { positionClass: 'toast-top-center' });
      return;
    }

    var isErro = false;

    this.dayOfWeeks.day.forEach(item => {

      if (item.dayCheck) {

        if ((item.initialTime == '000000' && item.finalTime == '000000') || (item.initialTime == '' && item.finalTime == '')) {

          this.dayOfWeeks.day[item.weekDay].isError = true;
          isErro = true;
          return;
        }

        if (item.initialTime.length !== 6 || item.finalTime.length !== 6) {

          this.dayOfWeeks.day[item.weekDay].isError = true;
          isErro = true;
          return;
        }
      }
    });

    if (isErro) {

      this.toastr.error('Não é possível salvar pois existe(m) campo(s) inválido(s).'
        , 'Erro', { positionClass: 'toast-top-center' });

      return;
    }

    this.panelConfigurationWorkingDay.businessProcessDimension = new BusinessProcessDimension();
    this.panelConfigurationWorkingDay.businessProcessDimension = this.businessProcessDimensionList.find(
      p => p.id === this.businessProcessDimension.id);
    this.panelConfigurationWorkingDay.stateDimensions = new Array<StateDimension>();
    this.panelConfigurationWorkingDay.workingDays = new Array<PanelConfigurationIndicatorWorkingDayItem>();
    this.panelConfigurationWorkingDay.nonWorkingDays = new Array<PanelConfigurationNonWorkingDayModel>();

    this.dayOfWeeks.day.forEach(item => {
      if (item.dayCheck) {

        this.workingDayItem = new PanelConfigurationIndicatorWorkingDayItem();

        this.workingDayItem.dayOfWeek = item.weekDay;
        this.workingDayItem.initialTime = this.toUtcDate(item.initialTime);
        this.workingDayItem.finalTime = this.toUtcDate(item.finalTime);
        // this.workingDayItem.initialTime = item.initialTime;
        // this.workingDayItem.finalTime = item.finalTime;

        // console.log (item.initialTime);
        // console.log (item.finalTime);
        this.panelConfigurationWorkingDay.workingDays.push(this.workingDayItem);
      }
    });

    this.selectedNonWorkingDays.forEach(item => {

      this.panelConfigurationWorkingDay.nonWorkingDays.push({
        id: item.id == null ? null : item.id,
        panelConfigurationNonWorkingDay: item
      });
    });

    this.items.filter(f => this.selectedStateDimensionList.indexOf(f.id) > -1)
        .forEach(item => {

      this.panelConfigurationWorkingDay.stateDimensions.push( {
          id: Number(item.id),
          name: item.text,
          displayName: item.text,
          businessProcessId: 0, stateId: 0, version: 0
      });
    });

    // this.stateDimensionList.forEach(item => {
    //   this.panelConfigurationWorkingDay.stateDimensions.push(item);
    // });

    this.isSaving = true;

    this.configurationService.saveWorkingDay(this.panelConfigurationWorkingDay)
      .subscribe(
        (resp: any) => {
          if (resp.result) {

            this.successfullySaved = true;
            this.toastr.success('Dias úteis salvo com sucesso!', 'Sucesso', { positionClass: 'toast-top-center' });
            this.isSaving = false;
            this.onCloseModal();

            if (this.filter !== undefined) {
              this.receiveFilter(this.filter);
            }

          } else if (resp.error) {

            this.successfullySaved = false;
            this.isSaving = false;
            this.toastr.error(resp.errorMessage, 'Erro', { positionClass: 'toast-top-center' });

          }
          this.isSaving = false;
        }
      );
  }

  // MODAL EDITAR
  configEditingModal(staticModel: TemplateRef<any>) {
    this.isOpenModal = true;

    if (this.panelConfigurationWorkingDay.workingDays === undefined || this.panelConfigurationWorkingDay.workingDays.length < 1) {
      this.toastr.error('Não é possível editar, pois é necessario filtrar um estado.'
        , 'Erro', { positionClass: 'toast-top-center' });
      return;
    }

    this.isEditing = true;
    this.loadModalEdit();

    this.bsModalRef = this.genericModalService.showObjModalWithTemplate(staticModel, {}, 'modal-xl');
  }

  loadModalEdit() {

    this.textAction = 'Editar';
    this.stateDimensionList = [];
    this.selectedNonWorkingDays = [];

    this.businessProcessDimension = this.businessProcessDimensionList.find(p => p.id === this.filter.BusinessProcess.id);
    this.bPListSelected = this.businessProcessDimension.name;

    this.onChangeBusinessProcess();

    this.dayOfWeeks = new DayOfWeeks(false);

    const options: SelectOption[] = [{
      id: this.filter.State.id.toString(),
      text: this.filter.State.name
    }];

    this._listClients = <SelectOption[]>options;
    console.log('listClients', this._listClients);

    this.selectedStateDimensionList = options.map(o => o.id);

    this.stateDimensionList.push({
      'id': this.filter.State.id.toString(),
      'name': this.filter.State.name,
      'displayName': this.filter.State.name
    });

    this.panelConfigurationWorkingDay.workingDays.forEach(item => {

      this.dayOfWeeks.day.find(p => p.weekDay === item.dayOfWeek).dayCheck = true;
      this.dayOfWeeks.day.find(p => p.weekDay === item.dayOfWeek).weekDay = item.dayOfWeek;
      this.dayOfWeeks.day.find(p => p.weekDay === item.dayOfWeek).initialTime = item.formatedInitialTime;
      this.dayOfWeeks.day.find(p => p.weekDay === item.dayOfWeek).finalTime = item.formatedFinalTime;
    });

    this.panelConfigurationWorkingDay.nonWorkingDays.forEach(item => {
      this.selectedNonWorkingDays.push(this.nonWorkingDays.find(p => p.id === item.panelConfigurationNonWorkingDay.id));
    });

    this.isEdit = true;
  }

  toUtcDate(date: string) {
    const hour = Number(date.substr(0, 2));
    const minutes = Number(date.substr(2, 2));
    const seconds = Number(date.substr(4, 2));
    const newDate = new Date();
    newDate.setHours(hour, minutes, seconds, 0);

    return new Date(newDate.toUTCString().substr(0, 25));
  }

  private getNowUTC(dateNow: Date) {
    return new Date(dateNow.getTime() + (dateNow.getTimezoneOffset() * 60000));
  }

  private getFormatMask(mask, value: string) {

    let result = '';

    for (let im = 0, is = 0; im < mask.length && is < value.length; im++) {
      result += mask.charAt(im) === 'X' ? value.charAt(is++) : mask.charAt(im);
    }
    return result;
  }

  onSelectionChange(entry) {

    this.checkboxDisabled = false;

    switch (entry.id) {
      case (0):

        for (let index = 0; index <= 6; index++) {
          this.dayOfWeeks.day[index].dayCheck = false;
        }

        this.checkboxDisabled = false;
        break;
      case (1):

        for (let index = 0; index <= 6; index++) {
          this.dayOfWeeks.day[index].dayCheck = true;
        }

        this.checkboxDisabled = false;
        break;
      case (2):

        this.dayOfWeeks = new DayOfWeeks(true);
        this.dayOfWeeks.day[0].dayCheck = false;
        this.dayOfWeeks.day[6].dayCheck = false;
        this.checkboxDisabled = true;

        this.checkboxDisabled = true;
        break;
      case (3):

        for (let index = 0; index <= 6; index++) {

          if (index == 0 || index == 6) {
            this.dayOfWeeks.day[index].dayCheck = true;
          } else {

            this.dayOfWeeks.day[index].dayCheck = false;
          }
        }

        this.checkboxDisabled = true;
        break;
      default:
        this.dayOfWeeks = new DayOfWeeks(false);
        this.checkboxDisabled = false;
        break;
    }
  }

  NoneChange() {
    this.dayOfWeeks = new DayOfWeeks(false);
    this.checkboxDisabled = false;
  }

  ngOnInit() {
    this.getBusinessProcess();
    this.listNonWorkingDays();
  }

  onCloseModal() {
    this.bsModalRef.hide();
    this.isOpenModal = false;
  }
}

export class DayOfWeeks {

  day: Array<DayOfWeek> = [];

  constructor(dayCheckStatus: boolean) {

    this.day = new Array<DayOfWeek>();

    for (let _i = 0; _i < 7; _i++) {
      this.day.push({
        weekDay: _i,
        dayCheck: dayCheckStatus,
        initialTime: '',
        finalTime: '',
        isError: false
      });
    }
  }

}

export class DayOfWeek {
  weekDay: number;
  dayCheck: boolean;
  initialTime: string;
  finalTime: string;
  isError: boolean;
}
